<template lang="pug">
  v-row(no-gutters)
    h2(class="subtitle-text") {{ subtitleName }}
</template>

<script>
export default {
  name: 'Subtitle',
  props: {
    subtitleName: {
      type: String,
      default: '',
      required: true
    }
  }
}
</script>

<style scoped>
.subtitle-text {
  font-weight: 700;
  font-size: 18px;
  letter-spacing: -0.94px;
  color: #000000;
  margin-bottom: 16px;
}
</style>
